import { useSelector, useDispatch } from 'react-redux';
import { filter } from 'lodash';
import React, { useEffect, useState } from 'react';
import { map } from 'lodash';
import { useHistory } from 'react-router-dom';
import { SHARE_PLACE_ROUTE } from '../router/routes';
import { Button } from '../utils/forms/Button';
import PermanentPlacesList from '../PermanentPlaces/PermanentPlacesList';
import { getUserPlaces } from '../../actions/parkingSpotActions';

export default function PermanentPlaces() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserPlaces());
  }, []);

  const userId = useSelector((state) => state.auth.id);

  const permanentPlaces = useSelector((state) =>
    filter(state.spots, (spot) => spot.userId === userId)
  );

  return (
    <div className="scrollable">
      {map(permanentPlaces, (place, id) => {
        const reservationTitle = `Stálé místo ${place.place}`;

        return (
          <div key={id}>
            <PermanentPlacesList
              reservationTitle={reservationTitle}
              place={place}
            />
          </div>
        );
      })}
    </div>
  );
}
